import React, { Component } from 'react';
import { debounce, identity } from 'lodash/fp';
import classNames from 'classnames';

class DebouncedTextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleChange = this.handleChange.bind(this);
    this.handlePaste = this.handlePaste.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.debouncedOnChange = props.disabled
      ? identity
      : debounce(props.wait)(props.onChange);
  }

  static defaultProps = {
    wait: 300,
    value: '',
    controlled: false,
    onChange: identity,
  };

  UNSAFE_componentWillReceiveProps({ value: nextValue }) {
    const { value } = this.textarea;
    if (this.props.controlled && value !== nextValue) {
      this.textarea.value = nextValue;
    }
  }

  componentDidMount() {
    global.autosize(this.textarea);
  }

  handleKeyDown(e) {
    if (this.props.singleLine && e.keyCode === 13) {
      e.preventDefault();
      this.setState({ shake: true });
      setTimeout(() => {
        this.setState({ shake: false });
      }, 500);
    }
  }

  handlePaste(e) {
    if (!this.props.singleLine) return;
    e.persist();
    requestAnimationFrame(() => {
      this.textarea.value = e.target.value.replace(/[\r\n|\n|\s]+/g, ' ');
      global.autosize.update(this.textarea);
      this.setState(
        {
          // The textarea in this component is uncontrolled, but perhaps it
          // should be or it was at some point but no longer is givin that
          // we're setting the value in the state.
          // eslint-disable-next-line react/no-unused-state
          value: e.target.value.replace(/[\r\n|\n|\s]+/g, ' '),
        },
        this.handleChange,
      );
    });
  }

  handleChange() {
    const changeHandler = !this.props.wait
      ? this.props.onChange
      : this.debouncedOnChange;
    changeHandler.call(this, this.textarea.value);
  }

  render() {
    const className = classNames(this.props.className, {
      Animated: true,
      'Animated--shake': this.state.shake,
    });

    const {
      singleLine,
      controlled,
      value,
      wait,
      maxLength,
      rows = 1,
      ...textareaProps
    } = this.props;

    return (
      <textarea
        {...textareaProps}
        rows={rows}
        ref={node => {
          this.textarea = node;
        }}
        className={className}
        defaultValue={value}
        onChange={this.handleChange}
        onKeyDown={this.handleKeyDown}
        onPaste={this.handlePaste}
        maxLength={maxLength}
      />
    );
  }
}

export default DebouncedTextArea;
